<template>
  <div class="form-group">
      <date-range-picker
        :locale-data="localeData"
        :singleDatePicker="options.singleDatePicker"
        :timePicker="options.timePicker"
        :timePicker24Hour="options.timePicker24Hour"
        :showWeekNumbers="options.showWeekNumbers"
        :showDropdowns="options.showDropdowns"
        :autoApply="options.autoApply"
        :ranges="ranges"
        :opens="opendir"
        :filtered="filtered"
        :close-on-esc="options.closeOnEsc"
        :linkedCalendars="options.linkedCalendars"
        v-model="dateRange"
        @select="selectValues"
        @toggle="checkOpen"
      >
        <template style="min-width: 500px;">
            {{ startDate }} - {{ endDate }}
        </template>
      </date-range-picker>
  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment';

export default {
  props: {
    opendir: { type: String, default: 'right' },
    filtered: { type: Boolean, default: false },
    initialStart: { type: [String, Date], default: null }, // aceptan 'DD/MM/YYYY', ISO o Date
    initialEnd: { type: [String, Date], default: null }
  },
  components: {
    DateRangePicker
  },
  data () {
    return {
      dateRange:{
          startDate: null,
          endDate: null
      },
      options:{
          singleDatePicker:false,
          timePicker:false,
          timePicker24Hour:true,
          showWeekNumbers:false,
          showDropdowns:true,
          autoApply:true,
          linkedCalendars:false,
          closeOnEsc:true,
      },
      localeData: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' || ',
          applyLabel: 'Aceptar',
          cancelLabel: 'Cancelar',
          weekLabel: 'Sem',
          customRangeLabel: 'Rango personalizado',
          daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
          monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          firstDay: 0
      },
      ranges:{}
    }
  },
  mounted: function () {
      this.initializeDefaultDateRange();
      this.ranges = {
          'Hoy': [moment().startOf('day').toDate(), moment().endOf('day').toDate()],
          'Ayer': [moment().subtract(1, 'days').startOf('day').toDate(), moment().subtract(1, 'days').endOf('day').toDate()],
          'Esta semana': [moment().startOf('week').toDate(), moment().endOf('week').toDate()],
          'Este mes': [moment().startOf('month').toDate(), moment().endOf('month').toDate()],
          'El mes pasado': [moment().subtract(1, 'months').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').toDate()],
          'Este año': [moment().startOf('year').toDate(), moment().endOf('year').toDate()],
          'Todos': [null, null],
      }
  },
  methods: {
    initializeDefaultDateRange() {
        // prioridad a props iniciales si vienen
        if (this.initialStart || this.initialEnd) {
            this.dateRange.startDate = this.parseToDate(this.initialStart);
            this.dateRange.endDate = this.parseToDate(this.initialEnd);
            return;
        }
        if(this.filtered === true){
            const today = new Date();
            const startDate = new Date();
            startDate.setDate(today.getDate() - 30);

            this.dateRange.startDate = moment(startDate).toDate();
            this.dateRange.endDate = moment(today).toDate();
        }else {
            this.dateRange.startDate = null;
            this.dateRange.endDate = null;
        }
    },

    // helper para aceptar String(Date) o Date
    parseToDate(val) {
        if (!val) return null;
        // moment maneja ISO y formatos comunes; si se pasa 'DD/MM/YYYY' también se detecta bien
        const m = moment(val, moment.ISO_8601, true);
        if (m.isValid()) return m.toDate();
        // fallback: intentar parse flexible
        const mf = moment(val, 'DD/MM/YYYY', true);
        if (mf.isValid()) return mf.toDate();
        const mf2 = moment(val);
        return mf2.isValid() ? mf2.toDate() : null;
    },    
      selectValues: function (val) {
          let data={
              'startDate':(moment(val.startDate).isValid()) ? moment(val.startDate).format("DD/MM/YYYY") : null,
              'endDate':(moment(val.endDate).isValid()) ? moment(val.endDate).format("DD/MM/YYYY") : null,
          };
          this.$emit('datepicked',data);
      },
      checkOpen: function () {},
  },
  computed: {
        startDate: {
            get: function () {
                if(this.dateRange.startDate!==null){
                    return moment(this.dateRange.startDate).format("DD/MM/YYYY");
                }
                return '';
            },
            set: function (value) {
                this.dateRange.startDate = value;
            }
        },
        endDate: {
            get: function () {
                if(this.dateRange.endDate!==null){
                    return moment(this.dateRange.endDate).format("DD/MM/YYYY");
                }
                return '';
            },
            set: function (value) {
                this.dateRange.endDate = value;
            }
        },
    },
    watch: {
        initialStart(newVal) { this.dateRange.startDate = this.parseToDate(newVal); },
        initialEnd(newVal) { this.dateRange.endDate = this.parseToDate(newVal); }
    },
}
</script>

<style lang="css">

</style>
